// extracted by mini-css-extract-plugin
export var divider = "_o0-0";
export var systemMessage = "_o0-1";